import React, { useContext, useEffect, useState } from "react";
import { userContext } from "../Contexts/userContext";
import { categoriesURL, currenciesURL } from "../Hooks/URL";
import CreateCategory from "../Templates/Home/Categories/CreateCategory/CreateCategory";
import { useNavigate, useParams } from "react-router";
import useFetch from "../Hooks/useFetch";

function EditCategoryPage() {
  const navigate = useNavigate();
  const { contextData, setContextData } = useContext(userContext);
  const { id } = useParams();
  const url = `${categoriesURL}/${id}`;

  const [category, setCategory] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const { data, loading, error } = useFetch(url);
  const { data: currenciesData, loading: currenciesLoading } = useFetch(currenciesURL);

  useEffect(() => {
    if (!loading && !error && data) {
      setCategory(data.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    if (!currenciesLoading && currenciesData) {
      setCurrencies(currenciesData.data || []);
    }
  }, [currenciesData, currenciesLoading]);

  useEffect(() => {
    setContextData({ ...contextData, page: "editCategory" });
  }, []);

  return (
    <CreateCategory
      navigate={navigate}
      categoriesURL={categoriesURL}
      categoryId={id}
      category={category}
      isEdit={true}
      loading={loading}
      currencies={currencies}
      currenciesLoading={currenciesLoading}
    />
  );
}

export default EditCategoryPage;

